export const createSetValueCurveAutomationEvent = (values, startTime, duration) => {
    return { duration, startTime, type: 'setValueCurve', values };
};
//# sourceMappingURL=create-set-value-curve-automation-event.js.map